<template>
  <div class="modal__parking-spots-template-wrapper">
      <div class="">
        <div v-if="descriptionTop" class="modal__description" v-html="descriptionTop"></div>
        <div class="modal__parking-spots-box">
          <div class="modal__subtitle">
            <translated-text-component translation="modal_parking_spaces_amount" />
          </div>
          <div class="modal__parking-spots-list">
            <div
              v-for="item in parkingSpotsItems" :key="item.category"
              class="modal__parking-spots-item">
              <i
                :class="[
                  '--category-'+item.category,
                  item.category == 'DISABLED' ? 'icomoon-park_dis': 'icomoon-park_car',
                ]"
                class="modal__parking-spots-icon"
              >
              </i>
              <div class="modal__parking-spots-number">{{item.spots}}</div>
            </div>
          </div>
        </div>
        <div v-if="parkingFreeSpotsItems.length" class="modal__parking-spots-free-box">
          <div class="modal__subtitle">
            <translated-text-component translation="modal_parking_free_spaces_amount" />
          </div>
          <div class="modal__parking-spots-list">
            <div
              v-for="item in parkingFreeSpotsItems" :key="item.category"
              :class="getStatusClassName(item.free)"
              class="modal__parking-spots-item">
              <i
                :class="[
                  '--category-'+item.category,
                  item.category == 'DISABLED' ? 'icomoon-park_dis': 'icomoon-park_car',
                ]"
                class="modal__parking-spots-icon"
              >
              </i>
              <div class="modal__parking-spots-number">{{item.free}}</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';

const TemplateModalParking: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalParking',
  setup(props) {
    const descriptionTop = ref('');
    const parkingSpotsItems = ref([]);
    const parkingFreeSpotsItems: Ref<any> = ref([]);
    const mergedArr = ref([]);
    const mergedArrValues: Ref<any> = ref([]);

    const getStatusClassName = (freeSpaces: number) => {
      return freeSpaces < 1 ? '--full' : '--free';
    };

    onMounted(() => {
      const { metaData } = props.templateData;
      const lastStatus: [] = metaData.last_status ? metaData.last_status.occupied_spots : [];
      const parkingSpots: [] = metaData.parking_spots ? metaData.parking_spots : [];
      descriptionTop.value = metaData.description;
      parkingSpotsItems.value = parkingSpots;

      mergedArr.value = [...lastStatus, ...parkingSpots];
      mergedArrValues.value = ModalTemplateService.mergeObjectsInUnique(mergedArr.value, 'category');

      if (metaData.last_status) {
        const parkingFreeSpots = lastStatus.map((statusItem: any) => {
            let freeSpaces = 0;
            parkingSpots.forEach((spot: any) => {
                if (statusItem.category === spot.category) {
                  freeSpaces = spot.spots - statusItem.occupied;
                }
            });

            return {
              ...statusItem,
              free: freeSpaces < 1 ? 0 : freeSpaces,
            };
        });
        parkingFreeSpotsItems.value = parkingFreeSpots;
      } else {
        parkingFreeSpotsItems.value = [];
      }
    });

    return {
      descriptionTop,
      mergedArrValues,
      parkingSpotsItems,
      parkingFreeSpotsItems,
      getStatusClassName,
    };
  },
});
export default TemplateModalParking;
</script>

<style scoped lang="scss">
.modal__subtitle {
  font-size: rem(16px);
  font-weight: 700;
  margin-bottom: rem(12px);
}

.modal__parking-spots {
  &-template-wrapper {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: rem(32px);
  }

  &-free-box {
    margin-top: rem(22px);
  }

  &-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 rem(-22px);
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 0 rem(22px);

    &.--full {
      color: $modal-parking_full_icon;

      .modal__parking-spots-icon {
        color: $modal-parking_full_icon;
      }
    }
    &.--free {
      color: $modal-parking_free_icon;
      .modal__parking-spots-icon {
        color: $modal-parking_free_icon;
      }
    }
  }

  &-icon {
    font-size: rem(24px);
    color: $modal-parking_standard_icon;
    margin-right: rem(15px);

    &::before {
      color: currentColor;
    }

    &.--category {
      &-disabled {
        font-size: rem(27px);
      }
    }
  }

  &-number {
    font-weight: 700;
  }

}
</style>
